<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div mat-dialog-content>
  <user-component [user]="user" [externalRoles]="externalRoles"></user-component>
</div>
